import vue from '@/main'
import Session from '@/client/session'
import { getFromLocal } from '@/utils'

const storedUser = getFromLocal(`hdyra-v-${process.env.NODE_ENV[0]}-locale`)

const mutations = {
  setCurrentUser (state, obj) {
    state.current = obj
  }
}

const getters = {
  currentUser (state) {
    return state.current
  }
}

const actions = {
  async login ({ commit }, credentials) {
    const data = await Session.login(credentials)

    vue.$auth.setStorage(data.data)
    commit('setCurrentUser', data.data)
  },

  async logout ({ commit }) {
    Session.logout()

    vue.$auth.removeStorage()
    commit('setCurrentUser', null)
  }
}

export default {
  state: {
    current: storedUser
  },
  actions,
  getters,
  mutations
}
